import React from 'react';
import { combineFilters, buildImageEffects } from '../utils/imageEffects';

interface UseGameFiltersParams {
  isBlurry: boolean;
  blurAmount: number;
  isNoColor: boolean;
  isInverted: boolean;
}

export function useGameFilters({ isBlurry, blurAmount, isNoColor, isInverted }: UseGameFiltersParams) {
  return React.useMemo(() => {
    const effects = buildImageEffects({ isBlurry, blurAmount, isNoColor, isInverted });
    return combineFilters(effects);
  }, [isBlurry, blurAmount, isNoColor, isInverted]);
}

